// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import FusePageCarded from '@fuse/core/FusePageCarded';
import Header from './components/Header';
import Content from './components/Content';
import HelmetWrapper from '@/app/shared-components/HelmetWrapper/HelmetWrapper';

const AddClientPage = () => {
  return (
    <>
      <HelmetWrapper />
      <FusePageCarded header={<Header />} content={<Content />} />;
    </>
  );
};

export default AddClientPage;
